@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    [headerIsFullWidth]="true"
    [noHeaderBorder]="true"
    [removeHeaderBottomPadding]="true"
    [hideFooter]="true"
    [noBodyPadding]="true"
    [rawWidth]="'99vw'"
    [rawHeight]="'99vh'"
    (close)="close()">
    <div class="modal-header header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center">
          <img src="assets/images/workflow-manager.svg" />
          <div class="title">{{ workflow?.name }}</div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          class="mr-3">
          <div class="ml-3">
            @if (isDirty) {
              <button
                class="header-button save-button"
                [ngClass]="{ 'disabled': !isDirty }"
                [disabled]="!isDirty"
                (click)="onSaveAndClose()">
                <span>{{ 'MANAGEMENT.BUTTONS.SAVE-CLOSE' | translate }}</span>
              </button>
            }
          </div>
          <div
            class="dialog-close ml-2 header-close"
            (click)="close()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div
        fxLayout="row"
        fxLayoutAlign="start top">
        <div
          class="drawer-container"
          [class.open]="isDrawerOpen">
          <topo-comms-left-drawer
            height="calc(99vh - 90px)"
            [isOpen]="isDrawerOpen"
            [showOpenCloseHandle]="true"
            (visibilityChanged)="drawerOpenClose($event)">
            <div class="template-properties">
              @if (!isHidden) {
                <div
                  class="properties-header"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  >
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="header-label">{{ 'MANAGEMENT.WORKFLOW.WORKFLOW-TEMPLATE' | translate | uppercase }}</div>
                  </div>
                </div>
              }
              <div class="body">
                <div class="field">
                  <label>{{ 'MANAGEMENT.WORKFLOW.PARENT-TYPE' | translate }}</label>
                  <div style="font-size: 0.875rem">{{ 'MANAGEMENT.WORKFLOW.PARENT-TYPE-' + workflow.parentType | translate }}</div>
                </div>
                <div class="field">
                  <label>{{ 'MANAGEMENT.WORKFLOW.NAME' | translate }}</label>
                  <div>
                    <input
                      class="input is-small is-fullwidth"
                      type="text"
                      placeholder="{{ 'MANAGEMENT.WORKFLOW.NAME' | translate }}"
                      (change)="setChanged()"
                      [(ngModel)]="workflowName" />
                  </div>
                </div>
                <div class="field">
                  <label>{{ 'MANAGEMENT.WORKFLOW.DESCRIPTION' | translate }}</label>
                  <div>
                    <textarea
                      class="input is-small is-fullwidth"
                      type="text"
                      cols="6"
                      placeholder="{{ 'MANAGEMENT.WORKFLOW.DESCRIPTION' | translate }}"
                      (change)="setChanged()"
                    [(ngModel)]="workflowDesc"></textarea>
                  </div>
                </div>
                <div class="field">
                  <label>{{ 'MANAGEMENT.WORKFLOW.COLUMNS.IS-ACTIVE' | translate }}</label>
                  <div>
                    <topo-switch
                      [checked]="isWorkflowActive"
                    (click)="checkWorkflowActive()"></topo-switch>
                  </div>
                </div>
                <div class="field">
                  <label>{{ 'MANAGEMENT.WORKFLOW.COLUMNS.IS-DEFAULT' | translate }}</label>
                  <div>
                    <topo-switch
                      [checked]="isWorkflowDefault"
                    (click)="checkWorkflowDefault()"></topo-switch>
                  </div>
                </div>
              </div>
            </div>
          </topo-comms-left-drawer>
        </div>
        <div
          class="workflow-body"
          [ngClass]="{ 'drawer-open': isDrawerOpen }">
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            class="workflow-header">
            <div class="step-count mr-4">
              {{ 'MANAGEMENT.WORKFLOW.NUMBER-WORKFLOW-STEPS' | translate : { steps: workflow?.workflowSteps?.length } }}
            </div>
            @for (step of workflow?.workflowSteps; track step.uId) {
              <div
                class="workflow-step-pill"
                fxLayout="row"
                fxLayoutAlign="start center"
                (click)="scrollToStep(step)">
                <div
                  class="status-color"
                [ngStyle]="{ 'background-color': step.statusHtmlColorCode || '#eeeeee' }"></div>
                <div class="status-name">{{ step.statusName || ('MANAGEMENT.DATASETS.NEW' | translate) }}</div>
              </div>
            }
            <div>
              <button
                title="{{ 'MANAGEMENT.WORKFLOW.ADD-WORKFLOW-STEP' | translate }}"
                class="button is-ghost"
                (click)="addWorkflowStep()">
                <i class="icon icon-add_plus_zoom-in"></i>
              </button>
            </div>
          </div>
          <div class="workflow-container">
            <div
              class="mt-5 mr-5"
              fxLayout="row"
              fxLayoutAlign="start start"
              cdkDropList
              cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="stepDrop($event)">
              <!-- Workflow Step Edit List Items-->
              @for (workflowStep of workflow?.workflowSteps; track workflowStep.uId) {
                <div
                  class="workflow-item editable"
                  cdkDrag
                  [id]="workflowStep.uId">
                  <div>
                    @if (workflowStepUIdToEdit !== workflowStep.uId) {
                      <div>
                        <div
                          fxLayout="row"
                          fxLayoutAlign="space-between center"
                          class="mb-2">
                          <div>{{ 'MANAGEMENT.WORKFLOW.STEP-TYPE-' + workflowStep.workflowStepType | translate }}</div>
                          <div
                            title="{{ 'MANAGEMENT.WORKFLOW.EDIT-STEP' | translate }}"
                            class="action-button icon icon-edit"
                          (click)="editStepClick(workflowStep)"></div>
                        </div>
                      </div>
                    }
                    @if (workflowStepUIdToEdit === workflowStep.uId) {
                      <div>
                        <topo-workflow-step-edit
                          [step]="workflowStep"
                          (save)="onStepEditSave($event)"
                          (cancel)="onStepEditCancel($event)"
                        (delete)="onStepEditDelete($event)"></topo-workflow-step-edit>
                        <div class="separator"></div>
                      </div>
                    }
                    <div
                      *cdkDragPreview
                      style="padding: 0px">
                      <topo-color-item-select
                        [selectedUId]="workflowStep.workflowStatusUId"
                        [label]="workflowStep.statusName"
                        [colorCode]="workflowStep.statusHtmlColorCode"
                      isLarge="true"></topo-color-item-select>
                    </div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center">
                      <topo-color-item-select
                        [selectedUId]="workflowStep.workflowStatusUId"
                        [label]="workflowStep.statusName"
                        [colorCode]="workflowStep.statusHtmlColorCode"
                        itemColorCode="htmlColorCode"
                        itemLabel="name"
                        [items]="status$ | async"
                        (itemSelected)="statusItemSelected(workflowStep, $event)"
                      isLarge="true"></topo-color-item-select>
                    </div>
                    <!-- Step Actions -->
                    <div>
                      @for (action of getNonEditableActions(workflowStep); track action.uId) {
                        <div
                          class="workflow-action"
                          cdkDrag>
                          @if (workflowStepActionUIdToEdit !== action.uId) {
                            <div
                              fxLayout="row"
                              >
                              <div>
                                <div class="left-action-line-top">&nbsp;</div>
                                <div class="left-action-line-bottom">&nbsp;</div>
                              </div>
                              <div>
                                <div class="left-action-line-middle">
                                  <div class="approve-reject">
                                    <img
                                      [src]="getActionTypeImage(action)"
                                      [title]="getActionTypeTitle(action)" />
                                  </div>
                                </div>
                              </div>
                              <div
                                style="margin-top: 12px"
                                [title]="action.label ?? ''">
                                <topo-color-item-select
                                  [selectedUId]="action.destinationStepUId"
                                  [label]="getActionName(action)"
                                  [colorCode]="getDestinationStepColor(action)"
                                  itemColorCode="statusHtmlColorCode"
                                  itemLabel="statusName"
                                  [items]="workflow?.workflowSteps"
                                  (itemSelected)="actionItemSelected(workflowStep, action, $event)"
                                isMedium="true"></topo-color-item-select>
                              </div>
                              <div
                                fxLayout="row"
                                fxLayoutAlign="center center">
                                <div
                                  title="{{ 'MANAGEMENT.WORKFLOW.EDIT-STEP-ACTION' | translate }}"
                                  class="action-edit-button icon icon-edit ml-4"
                                (click)="editStepActionClick(workflowStep, action)"></div>
                              </div>
                            </div>
                          }
                          @if (workflowStepActionUIdToEdit === action.uId) {
                            <div>
                              <topo-workflow-step-action-edit
                                [action]="action"
                                [isActive]="workflowStepActionUIdToEdit === action.uId"
                                [destinationName]="getDestinationStepName(action)"
                                [destinationColorCode]="getDestinationStepColor(action)"
                                (save)="onStepActionEditSave($event)"
                              (cancel)="onStepActionEditCancel($event)"></topo-workflow-step-action-edit>
                            </div>
                          }
                        </div>
                      }
                      <div class="workflow-action">
                        <div fxLayout="row">
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div
                      cdkDropList
                      (cdkDropListDropped)="actionDrop(workflowStep, $event)">
                      @for (action of getEditableActions(workflowStep); track action.uId) {
                        <div
                          class="workflow-action"
                          cdkDrag>
                          <div
                            *cdkDragPreview
                            style="padding: 0px; height: 22px">
                            <topo-color-item-select
                              [selectedUId]="action.destinationStepUId"
                              [label]="getActionName(action)"
                              [colorCode]="getDestinationStepColor(action)"
                            isMedium="true"></topo-color-item-select>
                          </div>
                          @if (workflowStepActionUIdToEdit !== action.uId) {
                            <div
                              fxLayout="row"
                              >
                              <div>
                                <div class="left-action-line-top">&nbsp;</div>
                                <div class="left-action-line-bottom">&nbsp;</div>
                              </div>
                              <div>
                                <div class="left-action-line-middle">&nbsp;</div>
                              </div>
                              <div
                                style="margin-top: 12px"
                                cdkDragHandle>
                                <topo-color-item-select
                                  [selectedUId]="action.destinationStepUId"
                                  [label]="getActionName(action)"
                                  [colorCode]="getDestinationStepColor(action)"
                                  itemColorCode="statusHtmlColorCode"
                                  itemLabel="statusName"
                                  [items]="workflow?.workflowSteps"
                                  (itemSelected)="actionItemSelected(workflowStep, action, $event)"
                                isMedium="true"></topo-color-item-select>
                              </div>
                              <div
                                fxLayout="row"
                                fxLayoutAlign="center center">
                                <div
                                  class="action-delete"
                                  style="margin-top: 12px"
                                  title="{{ 'MANAGEMENT.WORKFLOW.REMOVE-TRANSITION' | translate }}"
                                  (click)="deleteActionClick(workflowStep, action)">
                                  <i class="icon icon-remove_outline"></i>
                                </div>
                                <div
                                  cdkDragHandle
                                  style="cursor: pointer; margin-top: 12px; margin-left: 2px">
                                  <i class="icon icon-drag_handle drag-handle"></i>
                                </div>
                                <div
                                  title="{{ 'MANAGEMENT.WORKFLOW.EDIT-STEP-ACTION' | translate }}"
                                  class="action-edit-button icon icon-edit"
                                (click)="editStepActionClick(workflowStep, action)"></div>
                              </div>
                            </div>
                          }
                          @if (workflowStepActionUIdToEdit === action.uId) {
                            <div>
                              <topo-workflow-step-action-edit
                                [action]="action"
                                [isActive]="workflowStepActionUIdToEdit === action.uId"
                                [destinationName]="getDestinationStepName(action)"
                                [destinationColorCode]="getDestinationStepColor(action)"
                                (save)="onStepActionEditSave($event)"
                              (cancel)="onStepActionEditCancel($event)"></topo-workflow-step-action-edit>
                            </div>
                          }
                        </div>
                      }
                      <div class="workflow-action">
                        <div fxLayout="row">
                          <div>
                            <div class="left-action-line-top">&nbsp;</div>
                            <div class="left-action-line-bottom">&nbsp;</div>
                          </div>
                          <div>
                            <div
                              class="left-action-line-middle"
                              style="width: 36px">
                              &nbsp;
                            </div>
                          </div>
                          <div style="margin-top: 10px">
                            <button
                              class="button is-secondary is-small"
                              (click)="addActionClick(workflowStep, action)"
                              style="border-radius: 6px">
                              <i class="icon icon-add_plus_zoom-in"></i>
                              <span>{{ 'MANAGEMENT.WORKFLOW.ADD-TRANSITION' | translate }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Team Members -->
                    @if (workflowStep.workflowStepType === WorkflowStepTypes.Approval) {
                      <div
                        cdkDropList
                        (cdkDropListDropped)="memberDrop(workflowStep, $event)">
                        <div class="separator"></div>
                        <div class="approvers-title">
                          {{ 'MANAGEMENT.WORKFLOW.APPROVERS' | translate : { counter: workflowStep?.teamMembers?.length || 0 } }}
                        </div>
                        <div>
                          <label class="checkbox mt-2">
                            <div
                              fxLayout="row"
                              fxLayoutAlign="start center">
                              <input
                                type="checkbox"
                                [value]="'allAtOnce'"
                                [checked]="getIsAllAtOnce(workflowStep)"
                                (change)="allAtOnceChecked(workflowStep, $event)"
                                class="checkbox-size mr-3" />
                              <div class="checkbox-text">{{ 'MANAGEMENT.WORKFLOW.ALL-AT-ONCE' | translate }}</div>
                            </div>
                          </label>
                        </div>
                        @for (teamMember of workflowStep?.teamMembers; track teamMember.uId) {
                          <div
                            class="mt-2"
                            cdkDrag>
                            <div
                              *cdkDragPreview
                              class="approver-drag">
                              <div
                                fxLayout="row"
                                fxLayoutAlign="start center"
                                fxLayoutGap="12px">
                                <topo-avatar [name]="teamMember?.memberDisplayName"></topo-avatar>
                                <div>
                                  <div fxLayout="row">
                                    <div class="has-text-weight-semibold">{{ teamMember?.memberDisplayName }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              fxLayout="row"
                              fxLayoutAlign="space-between center"
                              style="width: 100%">
                              <div
                                class="approver"
                                cdkDragHandle>
                                <div
                                  class="px-2"
                                  fxLayout="row"
                                  fxLayoutAlign="start center"
                                  fxLayoutGap="12px">
                                  <topo-avatar [name]="teamMember?.memberDisplayName"></topo-avatar>
                                  <div>
                                    <div fxLayout="row">
                                      <div class="has-text-weight-semibold">{{ teamMember?.memberDisplayName }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                fxLayout="row"
                                fxLayoutAlign="center center">
                                <div
                                  class="action-delete member-delete"
                                  title="{{ 'MANAGEMENT.WORKFLOW.REMOVE-APPROVER' | translate }}"
                                  (click)="deleteMemberClick(workflowStep, teamMember)">
                                  <i class="icon icon-remove_outline"></i>
                                </div>
                                <div
                                  cdkDragHandle
                                  style="cursor: pointer">
                                  <i class="icon icon-drag_handle drag-handle"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="mt-2">
                          @if (selectMembers) {
                            <topo-team-member-select
                              [(ngModel)]="teamMembers"
                              placeholder="{{ 'MANAGEMENT.WORKFLOW.USER-OR-GROUP-ENTRY' | translate }}"
                            (selectedMembersChanged)="selectedMembersChanged(workflowStep, $event)"></topo-team-member-select>
                          }
                        </div>
                        <button
                          class="button is-secondary is-small mt-2"
                          (click)="addMemberClick()"
                          style="border-radius: 6px">
                          <i class="icon icon-add_plus_zoom-in"></i>
                          <span>{{ 'MANAGEMENT.WORKFLOW.ADD-APPROVER' | translate }}</span>
                        </button>
                      </div>
                    }
                    <!-- Step Rules -->
                    <div class="separator"></div>
                    <div>
                      <div
                        cdkDropList
                        (cdkDropListDropped)="ruleDrop(workflowStep, $event)">
                        <div class="rules-title">
                          {{ 'MANAGEMENT.WORKFLOW.RULES' | translate : { counter: workflowStep?.rules?.length || 0 } }}
                        </div>
                        @for (rule of workflowStep?.rules; track rule.uId) {
                          <div
                            cdkDrag>
                            <div
                              *cdkDragPreview
                              class="workflow-rule-drag">
                              <topo-workflow-rule-display [rule]="rule"></topo-workflow-rule-display>
                            </div>
                            <div
                              fxLayout="row"
                              fxLayoutAlign="start center">
                              <div
                                cdkDragHandle
                                (click)="editRuleClick(workflowStep, rule)"
                                class="workflow-rule">
                                <topo-workflow-rule-display [rule]="rule"></topo-workflow-rule-display>
                              </div>
                              <div
                                fxLayout="row"
                                fxLayoutAlign="center center">
                                <div
                                  class="action-delete"
                                  title="{{ 'MANAGEMENT.WORKFLOW.DELETE' | translate }}"
                                  (click)="deleteRuleClick(workflowStep, rule)">
                                  <i class="icon icon-remove_outline"></i>
                                </div>
                                <div
                                  cdkDragHandle
                                  style="cursor: pointer">
                                  <i class="icon icon-drag_handle drag-handle"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="mt-2">
                          <button
                            class="button is-secondary is-small"
                            (click)="addRuleClick(workflowStep)"
                            style="border-radius: 6px">
                            <i class="icon icon-add_plus_zoom-in"></i>
                            <span>{{ 'MANAGEMENT.WORKFLOW.ADD-RULE' | translate }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div
                class="workflow-item is-new-step"
                fxLayout="row"
                fxLayoutAlign="center center"
                (click)="addWorkflowStep()">
                <div
                  style="width: 320px"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <div>{{ 'MANAGEMENT.WORKFLOW.ADD-WORKFLOW-STEP' | translate }}</div>
                </div>
              </div>
              <div style="position: relative; width: 300px">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </topo-modal>
}

<topo-workflow-rule-edit></topo-workflow-rule-edit>
<topo-confirm-delete
  [isActive]="deleteContext"
(confirmResponse)="onConfirmDelete($event)"></topo-confirm-delete>
<topo-confirm
  [isActive]="showConfirmClose"
  (respond)="onConfirmClose($event)"
  title="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-CANCEL' | translate }}"
  message="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-CANCEL-MESSAGE' | translate }}"
  noText="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-NO' | translate }}"
  yesText="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-YES' | translate }}"
icon="icon-close-X"></topo-confirm>

<topo-confirm
  [isActive]="showConfirmValidation"
  (respond)="onConfirmValidation($event)"
  title="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-VALIDATION' | translate }}"
  [listItems]="validationList"
  [message]="validationMessage"
  noText="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-NO' | translate }}"
  yesText="{{ 'MANAGEMENT.WORKFLOW.CONFIRM-YES' | translate }}"
icon="icon-close-X"></topo-confirm>
